<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="我的二维码"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <!-- 海报 html 元素 -->
    <!-- <div v-if="posterImageArray==0">
      <div class="posterHtml" ref="posterHtml" v-for="(item,index) in posterBgArray" :key="index">
        <div class>
          <img :src="item" class="posterBg" @load="loadImage" />
          <div class="content">
            <div class="hd">
              <img :src="currentMember.HeadPic" alt class="avatar" />
            </div>
            <div class="bd">
              <p class="tit">HI,我是</p>
              <div class="name">{{currentMember.NickName}}</div>
              <div class="des">
                我为孝恩天堂代言
                <br />弘扬孝道&nbsp;播种大爱
              </div>
              <div
                class="qrcodeImg"
                :id="'qrcodeImg' + index"
                :ref="'qrcodeImg' + index"
                :if="postcode"
              ></div>
              <p class="tips">长按图片识别二维码</p>
              <img src="@/assets/images/logo.png" alt class="logo" />
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <div class="poster-tip">点击下方海报后，长按图片保存后发送给微信好友</div>
    <section class="swiper-area">
      <van-swipe :loop="false" @change="onChange" ref="posterSwiper">
        <van-swipe-item v-for="(item,index) in posterImageArray" :key="index">
          <div class="card_img">
            <img :src="item" />
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            <i v-text=" currentIndex + 1 "></i> /
            <i>{{posterBgArray.length}}</i>
          </div>
        </template>
      </van-swipe>
    </section>

    <section class="scroll-pic">
      <div
        v-for="(item,index) in posterBgArray"
        :key="index"
        class="item"
        @click="changePosteBg(index)"
      >
        <img :src="item" alt />
      </div>
    </section>
    <!-- <section class="scroll-pic">
      <div
        v-for="(item,index) in posterBgArray"
        :key="index"
        class="item"
        @click="changePosteBg(index)"
      >
        <img :src="item" alt />
      </div>
    </section>-->

    <div class="posterHtml" ref="posterHtml" v-for="(item,index) in posterBgArray" :key="index">
      <div class>
        <img :src="item" class="posterBg" @load="loadImage(index)" />
        <div class="content">
          <div class="hd">
            <img :src="currentMember.HeadPic" alt class="avatar" />
          </div>
          <div class="bd">
            <p class="tit">HI,我是</p>
            <div class="name">{{currentMember.NickName}}</div>
            <div class="des">
              我为孝恩天堂代言
              <br />弘扬孝道&nbsp;播种大爱
            </div>
            <div
              class="qrcodeImg"
              :id="'qrcodeImg' + index"
              :ref="'qrcodeImg' + index"
              :if="postcode"
            ></div>
            <p class="tips">长按图片识别二维码</p>
            <img src="@/assets/images/logo.png" alt class="logo" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import { ImagePreview } from "vant";
import { Toast } from "vant";
import { mapGetters, mapState } from "vuex";
import webconfig from '../../../webconfig.config'

export default {
  data() {
    return {
      posterBgArray: [
        require("@/assets/images/qrcode_bg/01.jpg"),
        require("@/assets/images/qrcode_bg/02.jpg"),
        require("@/assets/images/qrcode_bg/03.jpg"),
        require("@/assets/images/qrcode_bg/04.jpg"),
        require("@/assets/images/qrcode_bg/05.jpg"),
        // require("@/assets/images/qrcode_bg/06.jpg"),
        // require("@/assets/images/qrcode_bg/07.jpg"),
        // require("@/assets/images/qrcode_bg/08.jpg"),
        // require("@/assets/images/qrcode_bg/09.jpg"),
        // require("@/assets/images/qrcode_bg/10.jpg")
      ],
      postcode: "", // 生成的二维码
      postcodeImage: "",
      qrContentImage: "", // 最终生成的海报图片
      currentIndex: 0,
      posterImageArray: [
        require("@/assets/images/qrcode_bg/01.jpg"),
        require("@/assets/images/qrcode_bg/02.jpg"),
        require("@/assets/images/qrcode_bg/03.jpg"),
        require("@/assets/images/qrcode_bg/04.jpg"),
        require("@/assets/images/qrcode_bg/05.jpg"),
        // require("@/assets/images/qrcode_bg/06.jpg"),
        // require("@/assets/images/qrcode_bg/07.jpg"),
        // require("@/assets/images/qrcode_bg/08.jpg"),
        // require("@/assets/images/qrcode_bg/09.jpg"),
        // require("@/assets/images/qrcode_bg/10.jpg")
      ],
      lodingIndex: 0
    };
  },
  components: {},
  created() {
    var that = this;
    // that.$nextTick(() => {
    //   //that.createQrcode();
    //   that.createPosterArray();
    // });
    Toast.loading({
      mask: false,
      forbidClick: true,
      message: "生成中...",
      duration: 0
    });
  },
  computed: {
    ...mapGetters(["currentMember"]),
    ...mapState({
      qrcodeList: state => state.home.qrcodeList
    })
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");

    if (this.qrcodeList.length > 0) {
      this.posterImageArray = this.qrcodeList;
    }
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    createQrcode: function(index) {
      var id = this.currentMember.SerialNumber;
      // 生成二维码
      let qrcode = new QRCode("qrcodeImg" + index, {
        text: webconfig.WebDomin+"/app?id=" + id,
        width: 210,
        height: 210,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    createPosterArray(position) {
      var that = this;
      console.log("qrcodeList:" + this.qrcodeList.length);
      if (this.qrcodeList.length<this.posterImageArray.length) {
        var doc = this.$refs.posterHtml[position];
        this.createQrcode(position);
        this.createPoster(doc).then(x => {
          that.posterImageArray[position] = x;
          //that.posterImageArray.push(x);
          that.$set(
            that.posterImageArray,
            position,
            that.posterImageArray[position]
          );
          // that.qrcodeList.push(x);
          //console.log(that.posterImageArray);
           Toast.clear();
        });
        // for (var i = 0; i < this.posterBgArray.length; i++) {
        //   var doc = this.$refs.posterHtml[i];
        //   this.createQrcode(i);
        //   //let imgUrl = this.createPoster(this.$refs.posterHtml[i]);
        //  this.createPoster(doc).then(x=>{
        //        // console.log(x);
        //     that.posterImageArray[index]=x;
        //     //that.posterImageArray.push(x);

        //     that.$set(that.posterImageArray,index, that.posterImageArray[index])
        //       console.log(that.posterImageArray);
        //       index++;
        //   });
        //   //console.log(this.createPoster(this.$refs.posterHtml[i]));
        // }
      }
    },
    createPoster(doc) {
      // 生成海报
      var that = this;
      let shareContent = doc, //需要截图的包裹的（原生的）DOM 对象
        //width = shareContent.clientWidth, //shareContent.offsetWidth; //获取dom 宽度
        //height = shareContent.clientHeight, //shareContent.offsetHeight; //获取dom 高度
        width = 750, //shareContent.offsetWidth; //获取dom 宽度
        height = 1334, //shareContent.offsetHeight; //获取dom 高度
        canvas = document.createElement("canvas"), //创建一个canvas节点
        scale = 1; //定义任意放大倍数 支持小数
      canvas.width = width * scale; //定义canvas 宽度 * 缩放
      canvas.height = height * scale; //定义canvas高度 *缩放
      canvas.style.width = width * scale;
      canvas.style.height = width * scale;
      canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
      let opts = {
        scale: scale, // 添加的scale 参数
        canvas: canvas,
        logging: true,
        width: width,
        height: height,
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true
      };
      let postImage;
      return html2canvas(shareContent, opts)
        .then(function(canvas) {
          var context = canvas.getContext("2d");

          // 重要 关闭抗锯齿

          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;

          postImage = canvas.toDataURL("image/jpeg", 1.0);
          shareContent.style = "none";
          //that.posterImageArray.push(postImage);
          //that.qrcodeList.push(postImage);
          that.$nextTick(() => {
            shareContent.style.display = "none";
          });
          return postImage;
        })
        .catch(function(reason) {
          alert(reason);
        });
    },
    onChange(index) {
      this.currentIndex = index;
    },
    changePosteBg(index) {
      this.currentIndex = index;
      this.$refs.posterSwiper.swipeTo(index);
    },
    loadImage(index) {
      var that = this;
      //console.log(this.lodingIndex);

      // that.$nextTick(() => {
      //   //that.createQrcode();

      // });
      that.createPosterArray(index);
             this.lodingIndex++;
    }
  }
};
</script>

<style scoped>
.poster-tip {
  font-size: 12px;
  color: red;
  text-align: center;
  background-color: #fff59e;
  padding: 4px 15px;
}
.posterHtml {
  position: relative;
  width: 750px;
  height: 1334px;
  /* display: none; */
}
.posterBg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.posterHtml .content {
  position: relative;
  z-index: 1;
  padding-top: 15%;
}
.posterHtml .content .hd {
  width: 284px;
  height: 284px;
  border-radius: 50%;
  border: 12px solid rgba(255, 255, 255, 0.6);
  margin: 0 auto;
}
.posterHtml .content .hd .avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.posterHtml .content .bd {
  background-color: rgba(255, 255, 255, 0.7);
  width: 548px;
  border-radius: 24px;
  padding: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: -42px auto 0;
}
.posterHtml .content .bd .tit {
  font-size: 32px;
  color: #666;
  margin-top: 20px;
}
.posterHtml .content .bd .name {
  font-size: 42px;
  color: #222;
}
.posterHtml .content .bd .des {
  font-size: 42px;
  color: #444;
  margin-top: 30px;
  margin-bottom: 30px;
  text-align: center;
}
.posterHtml .content .bd .tips {
  font-size: 26px;
  color: #777;
  margin-top: 10px;
}
.posterHtml .content .bd .logo {
  width: 296px;
  display: block;
  margin-top: 40px;
}
.qrcodeImg {
  background-color: #fff;
  padding: 16px;
}
.card_img {
  width: 62%;
  margin: 24px auto;
}
.card_img img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}
.scroll-pic {
  display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}
.scroll-pic .item {
  width: 76px;
  flex-shrink: 0;
}
.scroll-pic .item img {
  display: block;
  width: 100%;
  height: 100%;
}
.swiper-area {
  height: auto;
}
.van-swipe {
  width: 100%;
  height: 100%;
}
.custom-indicator {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 35px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  width: 56px;
  margin: 0 auto;
  text-align: center;
}
</style>
